/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListProjectSequencesByJobParams = {
include_archived?: boolean;
/**
 * Match job title, sequence name, or sender name/email
 */
search?: string | null;
job_id?: string | null;
/**
 * @pattern ^(is|is_not)$
 */
job_op?: string;
steps?: number | null;
/**
 * @pattern ^(is|gt|gte|lt|lte)$
 */
steps_op?: string;
enrollments?: number | null;
/**
 * @pattern ^(is|gt|gte|lt|lte)$
 */
enrollments_op?: string;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 50
 */
per_page?: number;
};
